import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import config from '../config'; 

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 2,
        px: 4,
        mt: 'auto',
        backgroundColor: 'secondary.main',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2">
        &copy; {new Date().getFullYear()} {config.appName}. Todos los derechos reservados.
      </Typography>
      <Typography variant="body2">
        <Link href="/privacy" color="inherit" underline="hover">
          Política de Privacidad
        </Link>{' '}
        |{' '}
        <Link href="/terms" color="inherit" underline="hover">
          Términos y Condiciones
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
